module.exports = __webpack_public_path__ + "static/media/DSC00152.90f303bc.jpg";